<template>
  <div>
    <div v-if="compYouTubeUrl && !listingIs.timeRestricted" class="youtube-embed">
      <UtilIframe :url="compYouTubeUrl" class="absolute" />
    </div>

    <template v-if="compHealthData.length">
      <UtilDivider class="mt-5 mb-3" />

      <h3 class="text-xl font-medium">{{ $t('titles.health') }}</h3>

      <div class="flex flex-wrap mt-4">
        <div v-for="item in compHealthData" :key="item.key" class="mb-2 w-full sm:w-1/3 md:w-1/2 lg:w-1/3">
          <FontAwesomeIcon
            v-if="parseInt(listing.meta[item.key]) === 1"
            :icon="faCheckCircle"
            class="text-green-700 font-medium"
          />
          <FontAwesomeIcon v-else :icon="faTimes" />

          <span class="ml-1">{{ item.label }}</span>
        </div>
      </div>
    </template>

    <UtilDivider class="mt-5 mb-3" />

    <h3 class="text-xl font-medium">{{ $t('titles.general') }}</h3>

    <table class="table-auto table-striped-alt w-full mt-2">
      <tbody>
        <tr v-if="listing.meta.name">
          <td class="px-2 py-1 md:w-4/12">Name:</td>
          <td class="px-2 py-1 font-medium">{{ listing.meta.name }}</td>
        </tr>

        <tr v-if="listing.meta.dob">
          <td class="px-2 py-1 md:w-4/12">Age:</td>
          <td class="px-2 py-1 font-medium">
            {{ compAge }}
            <span class="font-normal">({{ listing.meta.dob }})</span>
          </td>
        </tr>

        <tr v-if="listing.meta.registered">
          <td class="px-2 py-1 md:w-4/12">
            <span v-if="listing.meta.isdsNo">Registration Number:</span>
            <span v-else>Registered:</span>
          </td>

          <td class="px-2 py-1 font-medium">
            <span v-if="listing.meta.isdsNo">{{ listing.meta.isdsNo }}</span>
            <span v-else>Yes</span>
          </td>
        </tr>

        <tr>
          <td class="px-2 py-1 md:w-4/12">Whelped:</td>
          <td class="px-2 py-1 font-medium">
            <span v-if="parseInt(listing.meta.litter)">Yes</span>
            <span v-else>No</span>
          </td>
        </tr>

        <tr v-if="parseInt(listing.meta.litter)">
          <td class="px-2 py-1 md:w-4/12">Number in Litter:</td>
          <td class="px-2 py-1 font-medium">{{ listing.meta.litter }}</td>
        </tr>

        <tr v-if="listing.meta.coatColour">
          <td class="px-2 py-1 md:w-4/12">Coat Colour:</td>
          <td class="px-2 py-1 font-medium">{{ listing.meta.coatColour }}</td>
        </tr>

        <tr v-if="listing.meta.coatType">
          <td class="px-2 py-1 md:w-4/12">Coat Type:</td>
          <td class="px-2 py-1 font-medium">{{ listing.meta.coatType }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { faCheckCircle, faTimes, faInfoCircle } from '@fortawesome/pro-regular-svg-icons'
import workingDogsHealth from '@/lib/helpers/working-dogs-health'
import calculateAge from '@/lib/calculate-age'
import UtilDivider from '@/components/utils/UtilDivider'
import UtilIframe from '@/components/utils/UtilIframe'

export default {
  name: 'ListingDetailsWorkingDogs',
  components: {
    UtilDivider,
    UtilIframe
  },
  props: {
    isLoading: Boolean,
    listing: {
      type: Object,
      required: true
    },
    listingIs: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      workingDogsHealth,
      faCheckCircle,
      faInfoCircle,
      faTimes
    }
  },
  computed: {
    compHealthData() {
      return workingDogsHealth.filter(item => parseInt(this.listing.meta[item.key]) === 1)
    },

    compAge() {
      let dob = this.listing.meta.dob

      // Working dogs in old listings seem to use Y-m-d
      if (this.listingIs.legacy) {
        dob = this.$date(dob, this.$date.legacyFormatDateOnlyReverse).format('DD-MM-YYYY')
      }

      return calculateAge(dob)
    },

    compYouTubeUrl() {
      if (!this.listing.meta.youTubeVideoUrl) {
        return null
      }

      try {
        let urlTest = /^(https?:\/\/)?((www\.)?(youtube(-nocookie)?|youtube.googleapis)\.com.*(v\/|v=|vi=|vi\/|e\/|embed\/|user\/.*\/u\/\d+\/)|youtu\.be\/)([_0-9a-z-]+)/i
        let videoId = this.listing.meta.youTubeVideoUrl.match(urlTest)[7]

        return `https://www.youtube.com/embed/${videoId}?start=0&version=3&enablejsapi=1&autoplay=0&modestbranding=1&color=white&rel=0&showinfo=0&autohide=1&iv_load_policy=3`
      } catch (error) {
        return null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.youtube-embed {
  position: relative;
  padding-bottom: 48.2%;

  & > div {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
}
</style>
